import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from '@/common/ui/table'

export const GAME_TYPE_TRANSLATIONS: Record<string, string> = {
	SLOT: 'สล็อต',
	FISHING: 'เกมยิงปลา',
	SPORT: 'กีฬา',
	LOTTO: 'หวย',
	CASINO: 'คาสิโน',
}

interface GameTypeDetailsModalProps {
	isOpen: boolean
	onClose: () => void
	gameTypeData: {
		gameType: string
		totalLossAmount: number
		totalBetAmount: number
		totalTurnoverAmount: number
		totalTransferIn: number
		totalTransferOut: number
		totalSettleAmount: number
	}[]
}

export default function GameTypeDetailsModal({
	isOpen,
	onClose,
	gameTypeData,
}: GameTypeDetailsModalProps) {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>รายละเอียดตามประเภทเกม</DialogTitle>
					<DialogDescription>ข้อมูลการเล่นแยกตามประเภทเกม</DialogDescription>
				</DialogHeader>
				<div className="mt-4">
					<Table>
						<TableHeader>
							<TableRow>
								<TableHead>ประเภทเกม</TableHead>

								<TableHead className="text-right">ยอดเทิร์น</TableHead>
							</TableRow>
						</TableHeader>
						<TableBody>
							{gameTypeData.map((item) => (
								<TableRow key={item.gameType}>
									<TableCell className="font-medium">
										{GAME_TYPE_TRANSLATIONS[item.gameType] || item.gameType}
									</TableCell>

									<TableCell className="text-right">
										{item.totalTurnoverAmount.toFixed(2)} บาท
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</div>
			</DialogContent>
		</Dialog>
	)
}
